import axios from "axios";
import { get, set } from "idb-keyval";

const API_URL = process.env.REACT_APP_WEB_ADMIN_URL;

const getRatingMatrix = async (receiverType) => {
  return (await axios.get(`${API_URL}/api/1/feedback/tags?type=${receiverType}`))?.data?.list;
};

const sendRatingForAppointment = async (appointmentId, rating) => {
  return (await axios.post(`${API_URL}/api/1/appointments/${appointmentId}/rate`, rating))?.data;
}

const getTipStatuses=  async (appointmentId) => {
  return (await axios.get(`${API_URL}/api/1/appointments/${appointmentId}/tip-status`))?.data;
}

export { getTipStatuses, sendRatingForAppointment, getRatingMatrix };
